export const hasErrorMessage = (
  error: string | null | undefined
): error is string => typeof error === 'string' && error.trim().length > 0;
